// extracted by mini-css-extract-plugin
export var equalColumn = "_j6-0";